export default __webpack_public_path__ + "static/media/time.12bc9ff2.jpg";